import Phone from '@letsdial/phone'
import { Events } from '@letsdial/phone/src/lib/types'
import { useCallStore } from '/@/store/callStore'
import { usePhoneStore } from '/@/store/phoneStore'
import useLetsDialSocket from '../letsDialSocket/useLetsDialSocket'
import { Howl } from 'howler'
import Ringtone from '/@/assets/sounds/ringback.ogg?url'
import { useAuthStore } from '/@/store/authStore'
import { DateTime } from 'luxon'

let sound: Howl | undefined

const onPhoneStatus = ({ status }) => {
  const phoneStore = usePhoneStore()
  const { socket } = useLetsDialSocket()
  const authStore = useAuthStore()
  phoneStore.setStatus(status)
  socket.emit('user:set:phone:status', { status })
  if (status === 'REGISTERED' && !authStore.pause) {
    authStore.setAvailabilityStatus('IDLE')
  }
}

const onCallStatus = ({ status, error }) => {
  const callStore = useCallStore()
  const authStore = useAuthStore()
  
  if (!sound) {
    const ringbackVolume = authStore.user?.attributes?.additionalAttributes?.ringbackVolume ?? 0.35
    sound = new Howl({
      src: [Ringtone],
      loop: true,
      volume: ringbackVolume,
    })
  }

  if (status === 'RINGING' || status === 'INITIATING') {
    const ringbackVol = authStore.user?.attributes?.additionalAttributes?.ringbackVolume ?? 0.35
    sound.volume(ringbackVol)
    sound.play()
  } else {
    sound.stop()
  }

  if (callStore.call?.id) {
    callStore.setStatus(status)
  } else {
    callStore.status = status
    callStore.statusChangedAt = DateTime.now()
  }

  if (status === 'TERMINATED' && !callStore.call?.id) {
    authStore.setAvailabilityStatus('IDLE')
  }

  if (error) {
    callStore.setError(error)
  }
}

export default function registerGlobalPhoneListeners(phone: Phone) {
  // Ensure we don't double-register if called again
  phone.off(Events.PHONE_STATUS, onPhoneStatus)
  phone.off(Events.CALL_STATUS, onCallStatus)
  
  phone.on(Events.PHONE_STATUS, onPhoneStatus)
  phone.on(Events.CALL_STATUS, onCallStatus)
}
